import React from 'react';
import PropTypes from 'prop-types';
import { useMantineTheme } from '@mantine/core';

/**
 * DecimalNumberFormatter is a formatter which simply passes decimal numbers trough, but
 * returns a dash for empty or null values.
 */
export const DecimalNumberFormatter = ({ value, style }) => {
  const { colorScheme, colors } = useMantineTheme();
  const styles = {
    span: {
      height: '100%',
      backgroundColor: colorScheme === 'dark' ? colors.dark[6] : 'white',
      color: colorScheme === 'dark' ? '#fff' : '#000',
      border: `1px solid ${colorScheme === 'dark' ? colors.dark[5] : colors.gray[2]}`,
      ...style,
    },
  };

  let stringValue = value.toString();
  if (stringValue.toString().includes('.')) {
    stringValue = stringValue.replace('.', ',');
  }

  return (
    <span className="form-control" style={styles.span}>
      {value === '' || value === null || value === undefined ? '-' : stringValue}
    </span>
  );
};

DecimalNumberFormatter.propTypes = {
  value: PropTypes.number,
};
